module.exports = __webpack_public_path__ + "static/boots_of_the_winterlands-486ad24f69174ab18f70daa3604d1d88.jpeg";